// Import dependencies
import { AutomatorSidebarPropertyChild } from '../_base';
import { unsafeCSS, css, html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { repeat } from 'lit/directives/repeat.js';

// Import style for web component
import styles from './web-component-style.scss';

// Get translatable strings
const strings = UncannyAutomatorBackend.logs.components.logSidebarProperty.i18n;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-log-sidebar-property-repeater' )
export class AutomatorLogSidebarPropertyRepeater extends AutomatorSidebarPropertyChild {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	/**
	 * Returns the template to render the value of the property
	 *
	 * @return {TemplateResult} The value of the property
	 */
	get _templateValue() {
		// Check if it's empty
		if ( this.parsedValue.length === 0 ) {
			return html`
				<code class="property-value">
					<em class="property-value__empty">${ strings.empty }</em>
				</code>
			`;
		}

		return html`
			<div class="property-value">
				<table class="repeater">
					<tbody>
						${ this._templateRepeaterTableRows }
					</tbody>
				</table>
			</div>
		`;
	}

	/**
	 * Returns the repeater rows (just <tr>s)
	 *
	 * @return {TemplateResult} The repeater rows
	 */
	get _templateRepeaterTableRows() {
		return repeat(
			this.parsedValue,
			( fieldColumns, rowIndex ) => rowIndex,
			( fieldColumns, rowIndex ) => html`
				<tr class="repeater-row">
					<td class="repeater-column repeater-column--number">
						<div class="repeater-column__row-number">
							${ ( rowIndex + 1 ) }
						</div>
					</td>
					<td class="repeater-column repeater-column--details">
						${
							repeat(
								Object.entries( fieldColumns ),
								( [ fieldCode, fieldValue ] ) => fieldCode,
								( [ fieldCode, fieldValue ] ) => html`
									<uap-log-sidebar-property
										.label="${ fieldCode }"
										.value="${ fieldValue }"
									></uap-log-sidebar-property>
								`,
							)
						}
					</td>
				</tr>
			`
		);
	}

	/**
	 * Tries to convert the value (string) into a valid array
	 *
	 * @return {Array} The parsed value
	 */
	get parsedValue() {
		try {
			return JSON.parse( this.value );
		} catch ( e ) {
			console.error( e );

			return [];
		}
	}
}
